import { createContext } from 'react';
import { WebsocketClientInstance } from 'auth/websocketClient';

const WebSocketContext = createContext<WebsocketClientInstance | null>(null);

export default WebSocketContext;
